// extracted by mini-css-extract-plugin
export default {"panel":"VerifyEmail_panel__AUI9Y"};